import { render, staticRenderFns } from "./modifyuser.vue?vue&type=template&id=adfce4c8&"
import script from "./modifyuser.vue?vue&type=script&lang=js&"
export * from "./modifyuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports